import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints, resolveEndpoint } from '../../endpoints';
import { ErrorService } from '../helpers/errorService';
import {
  DownloadFormRequest,
  FormSubmissionRecord,
  GetAllFormsRecordsResponse,
  SubmitFormApiResponse,
  SubmitFormRequest
} from '../models/form-record';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getAllFormsRecords(buildingId: string | number): Observable<FormSubmissionRecord[]> {
        const url = environment.apiBaseUrl + resolveEndpoint(endpoints.getAllFormsRecords, { buildingId });
        return this.http.get<GetAllFormsRecordsResponse>(url).pipe(
            map((response) => response.data ?? []),
            catchError(this.errorService.handleError)
        );
    }

    submitForm(request: SubmitFormRequest): Observable<SubmitFormApiResponse> {
        const url = environment.apiBaseUrl + resolveEndpoint(endpoints.submitForm, {
            buildingId: request.urlParams.buildingId,
            formType: request.urlParams.formType
        });

        return this.http.post<SubmitFormApiResponse>(url, request.body).pipe(
            catchError(this.errorService.handleSavingError.bind(this.errorService))
        );
    }

    downloadForm(request: DownloadFormRequest): Observable<Blob> {
        const url = environment.apiBaseUrl + resolveEndpoint(endpoints.downloadForm, {
            formId: request.formId
        });

        return this.http.get(url, { responseType: 'blob' }).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
